module.exports = "/images/logo.svg?ce123381af622d38c193e5d0739f26b2";